import * as React from "react";

/* istanbul ignore next */
export class Cta extends React.Component<{
    label: string
    selected?: boolean
}, {}> {
    /* istanbul ignore next */
    render() {
        let selected = this.props.selected ? true : false;
        return (
            <a href="javascript:;" data-selected={selected} className="racing-region-selector__label">{this.props.label}</a>
        )
    }
}